<template>
  <div>
    <a-row>
      <a-col :span="4" @click="showDrawer">
        <a-button
          v-if="!visible"
          type="primary"
          shape="circle"
          icon="menu-fold"
        />
        <a-button v-else type="default" shape="circle" icon="menu-unfold" />
      </a-col>
      <a-col :span="16">
        Chào,
        <strong>
          {{ auth.fullname || auth.email || auth.username }}
        </strong>
        !
      </a-col>
      <a-col :span="4">
        <!-- <a-button type="danger" shape="circle" icon="logout" @click="logout" /> -->
      </a-col>
      <a-col :span="24"><hr /></a-col>
    </a-row>

    <a-drawer
      :title="auth.fullname || auth.email || auth.username"
      placement="right"
      :closable="false"
      @close="onClose"
      :visible="visible"
      :afterVisibleChange="afterVisibleChange"
    >
      <div>
        <p v-if="auth.department && auth.department.name">
          <strong>Phòng ban:</strong> {{ auth.department.name }}
        </p>
        <p v-if="auth.position && auth.position.name">
          <strong>Phòng ban:</strong> {{ auth.position.name }}
        </p>
      </div>
      <!-- <p><router-link to="/form">Trình duyệt</router-link></p> -->
      <!-- <p><router-link to="/about">Giới thiệu</router-link></p>
      <p><router-link to="/auth">Đăng nhập</router-link></p> -->
      <!-- <div style="display:none">
        <p><router-link to="/templates">Word templates</router-link></p>
        <p><router-link to="/contentcontrol">Content Control</router-link></p>
      </div> -->
      <!-- <p @click="logout">Đăng xuất</p> -->
      <hr />
    </a-drawer>
  </div>
</template>
<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    auth() {
      return this.$store.state.auth;
    },
  },
  methods: {
    ...mapActions({
      logout: "auth/logout",
    }),
    afterVisibleChange(val) {
      // console.log("visible", val);
    },
    showDrawer() {
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
  },
};
</script>
